import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import highchartsExporting from "highcharts/modules/exporting";
import HighchartsMore from "highcharts/highcharts-more";
import highchartsOfflineExporting from "highcharts/modules/offline-exporting";
import HighchartsBoost from "highcharts/modules/boost";
import { getdatacolumnforDrilldown, fetchcolumndrilldowndata } from "../../actions/reportmanagement";
import HighchartsDrilldown from "highcharts/modules/drilldown";
import { Box, Button, Popover, TextField, List, ListItem, ListItemButton, CircularProgress } from "@mui/material";
import SecondLableDrilldown from "./SecondLableDrilldown";
import { toast } from "react-toastify";
import { decryptData } from '../utils/EncriptionStore';
import CalendarMonthSharpIcon from '@mui/icons-material/CalendarMonthSharp';
// Add at the top of your file
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import styles from "./DrilldownStyleCorrector.css"


HighchartsDrilldown(Highcharts);
HighchartsBoost(Highcharts);
HighchartsMore(Highcharts);
highchartsExporting(Highcharts);
highchartsOfflineExporting(Highcharts);


function Columndrilldown() {
    const [chartDatastore, setChartDatastore] = useState(null);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);

    const user = (() => {
        const encryptedData = localStorage.getItem("profile");
        return encryptedData ? decryptData(encryptedData) : null;
    })();

    const [dateRange, setDateRange] = useState([null, null]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const inputRef = useRef();


    // Define your options
    const dropdownOptions = [
        { label: "Last 7 Day(s)", value: 7 },
        { label: "Last 15 Day(s)", value: 15 },
        { label: "Last 1 Month(s)", value: 30 },
        { label: "Custom", value: "custom" },
    ];

    const [detaildorsecondleval, setDetailForSecondLeval] = useState(null)
    const data = useSelector((state) => state?.reportmanagement?.detailcolumndatafordrilldown)
    const searchParams = new URLSearchParams(window.location.search);
    const reportTitle = searchParams.get("report_title");
    const categoryValue = searchParams.get("category_value") || "";
    const selectedSeriesName = searchParams.get("selected_series_name") || "";
    const allcategory = JSON.parse(searchParams.get("selected_value_y_coordinate"));


    useEffect(() => {
        const fetchData = async () => {
            if (reportTitle && categoryValue) {
                setLoading(true);  // Enable loader
                await dispatch(
                    getdatacolumnforDrilldown({
                        customer_id: user?.customer_id,
                        master_report: reportTitle,
                        filter_value: categoryValue,
                        selectedSeriesName: selectedSeriesName,
                        database_type: user.database_type,
                    })
                );
                setLoading(false);  // Disable loader after data fetch
            }
        };
        fetchData();
    }, [reportTitle]);


    useEffect(() => {
        let chartData = {};
        if (!data || Object.keys(data).length === 0) {
            setChartDatastore(null);
            setDetailForSecondLeval(null)
            return;
        }
        const getNameFromValue = (value) => {
            for (let obj of data?.series) {
                if (obj.data?.includes(value)) {
                    return obj.name;
                }
            }
            return null;
        };
        const wantedInfo = (title, category, seriesName, value) => {
            const category_name = getNameFromValue(category);
            const wantedData = {
                report_title: title,
                category_name: category_name,
                category_value: category,
                selected_series_name: seriesName,
                selected_value_y_coordinate: value,
            };
            setDetailForSecondLeval(wantedData)
        };
        const pointEventdrill =
            data.drilldown !== "yes"
                ? {
                    click: function () {
                        const seriesName = this.options.name;
                        const category = data?.xAxis[0]?.categories[0] || this.name;
                        wantedInfo(data?.title, category, seriesName, this.y);
                    },
                }
                : {
                    click: function () {
                        toast.success("Drilldown is not enabled", {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            theme: "light",
                        });
                    },
                };
        if (data?.len_col > 2) {
            chartData = {
                chart: {
                    type: "column",
                    events: {
                    },
                },
                title: { align: "center", text: data?.title || "Chart" },
                accessibility: { announceNewData: { enabled: true } },
                xAxis: { categories: data?.series?.map((item) => item.name) || [] },
                yAxis: { title: { text: null } },
                legend: { enabled: false },
                credits: { enabled: false },
                plotOptions: {
                    series: {
                        borderWidth: 0,
                        cursor: "pointer",
                        point: { events: pointEventdrill },
                        dataLabels: { enabled: true, format: "{point.y}" },
                    },
                },
                tooltip: {
                    headerFormat: '<span style="font-size:11px">{point.name}</span><br>',
                    pointFormat:
                        '<span style="color:{point.color}">{point.name}</span>: ' +
                        "<b>{point.y}</b> of total<br/>",
                },

                series: [
                    {
                        boostThreshold: 1000,
                        name: data?.series[0]?.name || data?.xAxis[0].categories || "",
                        colorByPoint: true,
                        data: data?.series.map((entry) => ({
                            name: entry.name,
                            y: entry.data[0]
                        })) || [],
                    },
                ],

            };
        } else if (data?.len_col <= 2) {
            chartData = {
                chart: {
                    type: "column",
                    events: {
                    },
                },
                title: { align: "center", text: data?.title || "Chart" },
                accessibility: { announceNewData: { enabled: true } },
                xAxis: { categories: data?.xAxis[0]?.categories || [] },
                yAxis: { title: { text: null } },
                legend: { enabled: false },
                credits: { enabled: false },
                plotOptions: {
                    series: {
                        borderWidth: 0,
                        cursor: "pointer",
                        point: { events: pointEventdrill },
                        dataLabels: { enabled: true, format: "{point.y}" },
                    },
                },
                tooltip: {
                    headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                    pointFormat:
                        '<span style="color:{point.color}">{point.name}</span>: ' +
                        "<b>{point.y}</b> of total<br/>",
                },

                series: [
                    {
                        boostThreshold: 1000,
                        name: data?.series[0]?.name,
                        colorByPoint: true,
                        data: data?.series[0]?.data.map((name, index) => ({
                            name,
                            y: data?.series[1]?.data[index],
                        })) || [],
                    },
                ],

            };
        }
        setChartDatastore(chartData);
        setDetailForSecondLeval(null)
    }, [data]);

    const handleInputClick = (event) => {
        setAnchorEl(event.currentTarget);
        setOpen(true);
    };

    const handleQuickSelect = (days) => {
        if (days === "custom") {
            setDateRange([null, null]);
            return;
        }
        const end = new Date();
        const start = new Date();
        start.setDate(end.getDate() - days + 1);
        setDateRange([start, end]);
        // Optionally trigger fetch here
    };


    const formatDateLocal = (date) => {
        const offset = date.getTimezoneOffset();
        const localDate = new Date(date.getTime() - offset * 60 * 1000);
        return localDate.toISOString().slice(0, 10);
    };

    const handleApply = async () => {
        try {
            if (dateRange[0] && dateRange[1]) {
                //             const start_date = dateRange[0].toISOString().slice(0, 10);
                //             const end_date = dateRange[1].toISOString().slice(0, 10);
                const start_date = formatDateLocal(dateRange[0]);
                const end_date = formatDateLocal(dateRange[1]);
                setLoading(true);
                await dispatch(
                    fetchcolumndrilldowndata({
                        customer_id: user?.customer_id,
                        master_report: reportTitle,
                        selectedSeriesName: selectedSeriesName,
                        start_date,
                        end_date,
                        database_type: user.database_type,
                        filter_type: "range"
                    })
                );
            }
        } catch (error) {
            console.error("Failed to fetch column drilldown data:", error);
            toast.error("Failed to fetch data. Please try again.");
        } finally {
            setLoading(false);
            setOpen(false);
        }
    };

    const handleCancel = () => {
        setOpen(false);
    };


    return (
        <div>
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
                    <CircularProgress />
                </Box>
            ) : chartDatastore ? (

                <HighchartsReact
                    highcharts={Highcharts}
                    options={chartDatastore}
                    containerProps={{
                        style: {
                            height: "430px",
                            overflow: "hidden",
                            margin: "20px auto",
                            width: "90%",
                            border: "1px solid #0d6efd",
                            padding: "50px",
                            borderRadius: "20px",
                            boxShadow: "0 4px 8px 0 rgb(0 0 0 / 12%), 0 6px 10px 0 rgb(0 0 0 / 12%)"
                        }
                    }}
                />

            ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
                    <p>No data available</p>
                </Box>
            )}

            <Box
                sx={{
                    position: "absolute",
                    top: 25,
                    right: 100,
                    zIndex: 10,
                    background: "#fff",
                    borderRadius: "4px",
                    boxShadow: 1,
                    p: 1,
                }}
            >
                <TextField
                    inputRef={inputRef}
                    value={
                        dateRange[0] && dateRange[1]
                            ? `${dateRange[0].toLocaleDateString()} - ${dateRange[1].toLocaleDateString()}`
                            : ""
                    }
                    onClick={handleInputClick}
                    placeholder="Select date"
                    InputProps={{
                        endAdornment: (
                            <span role="img" aria-label="calendar" style={{ cursor: "pointer" }}><CalendarMonthSharpIcon /></span>
                        ),
                        readOnly: true,
                    }}
                    sx={{ width: 250 }}
                />
            </Box>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleCancel}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                PaperProps={{
                    sx: {
                        p: 2,
                        display: "flex",
                        gap: 2,
                        minWidth: 500,
                        minHeight: 320,
                    }
                }}
            >
                <Box sx={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 320 }}>
                    <Box sx={{ display: "flex", gap: 2, mb: 1 }}>
                        <TextField
                            label="From"
                            size="small"
                            value={dateRange[0] ? dateRange[0].toLocaleDateString() : ""}
                            onChange={e => {
                                const date = new Date(e.target.value);
                                setDateRange([date, dateRange[1]]);
                            }}
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            sx={{ flex: 1 }}
                            inputProps={{
                                value: dateRange[0]
                                    ? dateRange[0].toISOString().substring(0, 10)
                                    : "",
                                readOnly: true,
                            }}
                        />
                        <TextField
                            label="To"
                            size="small"
                            value={dateRange[1] ? dateRange[1].toLocaleDateString() : ""}
                            onChange={e => {
                                const date = new Date(e.target.value);
                                setDateRange([dateRange[0], date]);
                            }}
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            sx={{ flex: 1 }}
                            inputProps={{
                                value: dateRange[1]
                                    ? dateRange[1].toISOString().substring(0, 10)
                                    : "",
                                readOnly: true,
                            }}
                        />
                    </Box>
                    <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
                        <ReactDatePicker
                            selected={dateRange[0]}
                            onChange={date => setDateRange([date, dateRange[1]])}
                            selectsStart
                            startDate={dateRange[0]}
                            endDate={dateRange[1]}
                            inline
                            calendarStartDay={1}
                        />
                        <ReactDatePicker
                            selected={dateRange[1]}
                            onChange={date => setDateRange([dateRange[0], date])}
                            selectsEnd
                            startDate={dateRange[0]}
                            endDate={dateRange[1]}
                            minDate={dateRange[0]}
                            inline
                            calendarStartDay={1}
                        />
                    </Box>
                </Box>
                <Box sx={{ minWidth: 150, display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
                    <List sx={{ border: '1px solid rgb(13, 110, 253)', borderRadius: '20px', boxShadow: 'rgba(0, 0, 0, 0.12) 0px 4px 8px 0px, rgba(0, 0, 0, 0.12) 0px 6px 10px 0px' }}>
                        {dropdownOptions.map(opt => (
                            <ListItem key={opt.value} disablePadding>
                                <ListItemButton
                                    selected={
                                        (opt.value !== "custom" &&
                                            dateRange[0] &&
                                            dateRange[1] &&
                                            (dateRange[1] - dateRange[0]) / (1000 * 60 * 60 * 24) + 1 === opt.value
                                        ) || (opt.value === "custom" && (!dateRange[0] || !dateRange[1]))
                                    }
                                    onClick={() => handleQuickSelect(opt.value)}
                                    sx={{
                                        borderRadius: 1,
                                        mb: 0.5,
                                        "&.Mui-selected": {
                                            bgcolor: "#e3f2fd",
                                            color: "#1976d2",
                                        }
                                    }}
                                >
                                    {opt.label}
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                </Box>
                <Box
                    sx={{
                        position: "absolute",
                        bottom: 20,
                        right: 8,
                        display: "flex",
                        gap: 1,
                    }}
                >
                    <Button
                        variant="contained"
                        size="small"
                        onClick={handleApply}
                        disabled={!dateRange[0] || !dateRange[1]}
                        sx={{ minWidth: 80 }}
                    >
                        Apply
                    </Button>
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={handleCancel}
                        sx={{ minWidth: 80 }}
                    >
                        Cancel
                    </Button>
                </Box>
            </Popover>
            <Box>
                {detaildorsecondleval ? (
                    <SecondLableDrilldown detaildorsecondleval={detaildorsecondleval} />
                ) : (
                    <p>...</p>
                )}
            </Box>


        </div>
    );
}

export default Columndrilldown;
